import { langList } from '@/assets/enumerate/comEnumerate'
import { message } from 'ant-design-vue'

// 时间补零
function addZero(num) {
  if (parseInt(num) < 10) {
    num = '0' + num
  }
  return num
}
// 数组去重
export const unique = arr => {
  if (!Array.isArray(arr)) {
    return
  }
  let array = []
  for (let i = 0; i < arr.length; i++) {
    if (array.indexOf(arr[i]) === -1) {
      array.push(arr[i])
    }
  }
  return array
}
// 根据某个属性去重
export const unique2 = (arr, prop) => {
  const res = new Map()
  return arr.filter(a => !res.has(a[prop]) && res.set(a[prop], 1))
}
// 时间格式化
export const dataFormat = (time, isUser = false, style) => {
  if (!time || (+time === 0 && !isUser)) return '-'
  let date = new Date(time * 1000)
  let timeYYR =
    date.getFullYear() +
    '-' +
    addZero(date.getMonth() + 1) +
    '-' +
    addZero(date.getDate())
  time =
    date.getFullYear() +
    '-' +
    addZero(date.getMonth() + 1) +
    '-' +
    addZero(date.getDate()) +
    ' ' +
    addZero(date.getHours()) +
    ':' +
    addZero(date.getMinutes()) +
    ':' +
    addZero(date.getSeconds())
  if (style === 'YYR') {
    return timeYYR
  } else {
    return time
  }
}
// 文件大小格式转换
export const fileSizeFormat = fileSize => {
  if (!fileSize) return ''
  let size = parseInt(fileSize)
  if (size > 1024 * 1024) {
    // 四舍五入保留1位小数
    size = (size / 1024 / 1024).toFixed(1) + 'MB'
  } else if (size > 1024) {
    size = (size / 1024).toFixed(1) + 'KB'
  } else {
    size = size.toFixed(1) + 'B'
  }
  return size
}
// 判断分页跳转页面合法性
export const isTruePage = (page, totalPage, currNum) => {
  // let a = '   '
  // // console.log('a', parseInt(a))
  // page += "";
  page = parseInt(page)
  if (isNaN(page) || !page) {
    page = currNum
    return page
  }
  if (page > totalPage) {
    page = totalPage
  } else if (page <= 0) {
    page = currNum
  }
  return page
}
// 判断数组b 是否包含于a
export const isContained = (a, b) => {
  // if (!(a instanceof Array) || !(b instanceof Array)) return false
  // if (a.length < b.length) return false
  // let aStr = a.toString()
  // for (let i = 0, len = b.length; i < len; i++) {
  //   if (aStr.indexOf(b[i]) == -1) return false
  // }
  // return true
  return b.every(element => a.includes(element))
}
export const isArrayEqual = (value1 = [], value2 = []) => {
  // 判断是否是完全相同的两个数组

  function copy(value) {
    return JSON.parse(JSON.stringify(value))
  }

  let hash = copy(value2)
  if (value1.length === value2.length) {
    for (let i = 0; i < value1.length; i++) {
      const index = hash.indexOf(value1[i])
      if (index > -1) {
        hash.splice(index, 1)
      } else {
        return false
      }
    }
    return true
  }
  return false
}
// 数量超过一定 显示规范
export const showNum = num => {
  // if (typeof num !== 'number') return ''
  if (!num) return 0
  num = parseInt(num)
  if (num < 10000) return num
  if (num < 100000) return (num / 10000).toFixed(2) + 'w'
  return '10w+'
}
export const uuid = () => {
  let s = []
  let hexDigits = '0123456789abcdef'
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  return s.join('')
}
// 客户端下载文件
export function downloadNamedFile(name, url) {
  // console.log("name", name);
  if (url) {
    const a = document.createElement('a')
    a.download = name
    const href = url
      .replace(/\+/g, '%2B')
      .replace(/\?/g, '%3F')
      .replace(/#/g, '%23')
      .replace(/&/g, '%26')
      .replace(/=/g, '%3D')
    a.href = href
    a.target = '_blank'
    document.body.appendChild(a)
    a.click()
    a.parentNode.removeChild(a)
  }
}
// 在下载模型的时候 发现下载链接用上面的方式会把url改掉导致不能下载，怕直接改这个方法导致其他下载出问题，再写一个
export function downloadNamedFile2(name, url, blank = true) {
  if (url) {
    const a = document.createElement('a')
    a.download = name
    a.href = url
    if (blank) {
      a.target = '_blank'
    }
    document.body.appendChild(a)
    a.click()
    a.parentNode.removeChild(a)
  }
}
export async function downloadBlobWithName(name, url) {
  if (!url) return
  try {
    const res = await fetch(url, {
      // 若后端需要携带 cookie 改为 'include'
      credentials: 'omit'
    })
    if (!res.ok) {
      console.error('下载失败，尝试使用备用方式下载')
      // return downloadNamedFile2(name, url)
    }
    const blob = await res.blob()
    const objectUrl = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.download = name
    a.href = objectUrl
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    // 延迟 revoke 避免还未开始读取
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1500)
  } catch (e) {
    console.error('下载失败', e)
    // 回退原逻辑
    downloadNamedFile2(name, url)
  }
}
// 对象深拷贝
export function jsonDeepClone(obj) {
  if (obj && obj instanceof Object) {
    return JSON.parse(JSON.stringify(obj))
  } else {
    return obj
  }
}

// 对象深拷贝 尽量用这个
export function deepClone(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj // 如果是基本类型，直接返回
  }

  // 创建一个新的对象来拷贝
  let clone = Array.isArray(obj) ? [] : {}
  let key
  for (key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clone[key] = deepClone(obj[key])
    }
  }

  return clone
}

// 自定义错误信息
export function validateRemark(value, message) {
  if (!value) {
    return {
      validateStatus: 'error',
      errorMsg: message
    }
  } else {
    return {}
  }
}
export const resetCate = node => {
  // 去掉空children
  if (!node.children) {
    node.children = []
  } else {
    node.children.forEach(chi => {
      resetCate(chi)
    })
  }
  return node
}
export const dataToSecond = ({ d, h, m, s }) => {
  // 时间转为具体秒数
  let second = 0
  if (s) second += s
  if (m) second += m * 60
  if (h) second += h * 60 * 60
  if (d) second += d * 24 * 60 * 60
  return second
}
export const secondToData = s => {
  if (!s) return {}
  const days = Math.floor(s / (24 * 60 * 60))
  const hSecond = s % (24 * 60 * 60)
  const hours = Math.floor(hSecond / (60 * 60))
  const mSecond = hSecond % (60 * 60)
  const minutes = Math.floor(mSecond / 60)
  const seconds = mSecond % 60
  return { days, hours, minutes, seconds }
}
// 根据分类id获取分类名字
export const getClassName = ({ id, list }) => {
  let currClass
  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    if (item.id === id) {
      currClass = item
      return currClass
    } else if (item.children && item.children.length > 0) {
      currClass = getClassName({
        id,
        list: item.children
      })
      if (currClass) {
        return currClass
      }
    }
  }
  return currClass
}
// 根据分类id获取分类名字（包含父分类）
export const getClassName2 = ({ id, list, path = [] }) => {
  // 查找节点路劲
  const func = item => item.id + '' === id + ''
  if (!list) return []
  for (const data of list) {
    path.push(data)
    if (func(data)) return path
    if (data.children && data.children.length) {
      const findChildren = getClassName2({ list: data.children, path, id })
      if (findChildren.length) return findChildren
    }
    path.pop()
  }
  return []
}

/**
 * toLocaleString('en-US') 会按美式数字格式输出，自动加千分位逗号
 * digits 浮点数 默认是整数
 */
export const resetNum = (num, digits = 0) => {
  if (!num) return 0
  return Number(num).toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
}

/**
 * 保留两位小数
 * @param {Number} x
 * @returns {string} s
 */
export const toDecimal2 = x => {
  let f = parseFloat(x)
  if (isNaN(f)) {
    return false
  }
  f = Math.round(x * 100) / 100
  let s = f.toString()
  let rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}
/**
 * 分转元
 * @param {Number} fen
 * @returns {Number} num
 */
export const regFenToYuan = fen => {
  let num = fen
  num = fen * 0.01
  num += ''
  let reg =
    num.indexOf('.') > -1
      ? /(\d{1,3})(?=(?:\d{3})+\.)/g
      : /(\d{1,3})(?=(?:\d{3})+$)/g
  num = num.replace(reg, '$1')
  num = toDecimal2(num)
  return num
}
/**
 * 元转分
 * @param {Number} yuan
 * @param {Number} digit
 * @returns {Number} 分
 */
export const regYuanToFen = (yuan, digit = 100) => {
  let m = 0,
    s1 = yuan.toString(),
    s2 = digit.toString()
  try {
    m += s1.split('.')[1].length
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}

// 保留n位小数，并向上取整进1
export const upFixed = (number, fix = 2) => {
  if (!number) {
    return 0
  }
  if (!(fix >= 0 && fix <= 100)) {
    throw new RangeError('toCeil() digits argument must be between 0 and 100.')
  }

  let val = Math.ceil(number * Math.pow(10, fix)) / Math.pow(10, fix) + ''
  if (fix > 0) {
    const intp = val.split('.')[0],
      decp = val.split('.')[1] || ''
    if (decp.length < fix) {
      val = intp + '.' + decp.padEnd(fix, '0')
    }
  }

  return val
}

// 多语言列表
export const moreLangList = () => {
  const env = process.env.NODE_ENV
  const defaultLang = [
    { lang: langList.fr, label: '法语' },
    { lang: langList.es, label: '西班牙' },
    { lang: langList.nl, label: '荷兰' },
    { lang: langList.it, label: '意大利' }
  ]
  let _list = []
  if (env === 'international' || env === 'preInt') {
    _list.push({ lang: langList.zh, label: '中文' })
  } else {
    _list.push({ lang: langList.en, label: '英文' })
  }
  return [..._list, ...defaultLang]
}

// 公共复制工具  text 文本   isLine 是否换行  默认不换行
export const copyTool = (text, isLine) => {
  if (!text) return
  const dom = isLine ? 'textarea' : 'input'
  let transfer = document.createElement(dom)
  transfer.style.position = 'fixed'
  document.body.appendChild(transfer)
  transfer.value = text
  transfer.focus()
  transfer.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
  }
  transfer.blur()
  document.body.removeChild(transfer)
  message.success('复制成功')
}

// 版本对比
export const compareVersion = (version1, version2) => {
  const arr1 = version1.split('.')
  const arr2 = version2.split('.')
  const length1 = arr1.length
  const length2 = arr2.length
  const minlength = Math.min(length1, length2)
  let i = 0
  for (i; i < minlength; i++) {
    const a = arr1[i]
    const b = arr2[i]
    if (a > b) {
      return 1
    } else if (a < b) {
      return -1
    }
  }
  if (length1 > length2) {
    for (let j = i; j < length1; j++) {
      if (parseInt(arr1[j]) !== 0) {
        return 1
      }
    }
    return 0
  } else if (length1 < length2) {
    for (let j = i; j < length2; j++) {
      if (parseInt(arr2[j]) !== 0) {
        return -1
      }
    }
    return 0
  }
  return 0
}

export const versionContrast = ({ n, o }) => {
  if (!o) return -1
  if (n.includes('rasp_v')) {
    n = n.replace('rasp_v', '')
  } else {
    n = n.replace('V', '')
  }
  if (o.includes('rasp_v')) {
    o = o.replace('rasp_v', '')
  } else {
    o = o.replace('V', '')
  }
  return compareVersion(n, o)
}

// 16进制颜色转rgba
export const hexToRgba = (hex, opacity) => {
  let op = opacity
  if (opacity === null || opacity === undefined) {
    op = 1
  }
  if (!hex) hex = '#ededed'
  return (
    'rgba(' +
    parseInt('0x' + hex.slice(1, 3)) +
    ',' +
    parseInt('0x' + hex.slice(3, 5)) +
    ',' +
    parseInt('0x' + hex.slice(5, 7)) +
    ',' +
    op +
    ')'
  )
}

// 根据数组中的 value 去找 label
export function fillterEnum(v, list) {
  if (v) {
    const obj = list.find(item => {
      return item.value === v
    })
    if (obj) {
      return obj.label
    } else {
      return '/'
    }
  } else {
    return '/'
  }
}

// 当前颜色是否是深色 color 颜色   isCenter 是否是从中间开始算，默认不是 是从白色开始算
export function isDarkColor(color, isCenter) {
  if (!color) return true
  // 去掉颜色值前面的 # 号
  color = color.replace('#', '')

  // 如果颜色是3位格式，则转换为6位格式
  if (color.length === 3) {
    color = color
      .split('')
      .map(char => char + char)
      .join('')
  }

  // 处理argb颜色
  if (color.length === 8) {
    color = color.slice(2)
  }

  // 将十六进制颜色转换为 RGB 格式
  let r = parseInt(color.substr(0, 2), 16)
  let g = parseInt(color.substr(2, 2), 16)
  let b = parseInt(color.substr(4, 2), 16)
  // 根据 YIQ 公式计算亮度
  let brightness = (r * 299 + g * 587 + b * 114) / 1000
  // 130 是颜色深色和浅色的边界值 250以上基本都是白色
  const limit = isCenter ? 125 : 250
  // 如果亮度小于等于 250，则认为是深色（排除白色）
  return brightness <= limit
}

/**
 * 阿里云图片裁剪方法;
 * @param {String} url 图片url url必填
 * @param {Number} size 图片尺寸 正方形图片传这个
 * @param {Number} w 图片宽
 * @param {Number} h 图片高   size、w、h 任意传一个
 * @param {String} cutType 裁剪方式  默认m_fill图片被强行“拉伸”或“裁切”会改变图片比例   m_lfit 保留图片比例且限制最大宽高
 */
export function aliOssImageCut({ url, size, w, h, cutType = 'm_lfit' }) {
  if (!url) return ''
  let isWebp = false
  let isGif = false
  const typeArr = url.split('.')
  if (typeArr.length > 1) {
    const type = typeArr[typeArr.length - 1]
    if (type === 'webp') {
      isWebp = true
    }
    if (type === 'avif' || type === 'awebp' || type === 'gif') {
      isGif = true
    }
  }
  if (isGif) return url
  let ossSize = ''
  if (size) {
    ossSize = `,w_${size},h_${size}`
  }
  if (w && h) {
    ossSize = `,w_${w},h_${h}`
  }
  let format = isWebp ? '' : '/format,webp'
  const resUrl = `${url}?x-oss-process=image/resize,${cutType}${ossSize}${format}/ignore-error,1`
  return resUrl
}

/**
 * 自动滚动到 a-form-model 触发 rules 规则的视图
 * 使用示例：
 *  
    formRef.validate(valid => {
      if (!valid) {
        scrollToFirstError()
        return
      }
    })
 */
export function scrollToFirstError() {
  // 找到第一个带错误提示的表单项
  // 定时器是因为 表单报错的时候有个动态生成dom的操作。 可能在执行这个方法时 dom 由于表单复杂性还没生成好。
  // 所以加定时器，定时器是为了让这个JS线程放最后
  const t = setTimeout(() => {
    const el = document.querySelector(
      '.ant-form-item-with-help, .ant-form-item-control.has-error'
    )
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
    clearTimeout(t)
  }, 50)
}

/**
 * 分片计算文件的SHA1（支持大文件）
 * @param {File} file - 要计算的文件对象
 * @param {Function} onProgress - 进度回调，参数为 { loaded, total }
 * @returns {Promise<string>} 返回40位的SHA1字符串
 */
export async function calculateFileSHA1(file, onProgress = null) {
  const chunkSize = 2 * 1024 * 1024 // 分片大小：2MB，可根据需要调整
  const totalChunks = Math.ceil(file.size / chunkSize)
  let currentChunk = 0

  // 初始化sha1对象，用于累积更新
  const sha1 = window.sha1 || require('js-sha1').sha1 // 兼容CDN和模块引入
  const hash = sha1.create()

  while (currentChunk < totalChunks) {
    const start = currentChunk * chunkSize
    const end = Math.min(start + chunkSize, file.size)
    const chunk = file.slice(start, end) // 切割文件片段

    // 读取片段为ArrayBuffer
    const buffer = await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = e => resolve(e.target.result)
      reader.onerror = e => reject(e.target.error)
      reader.readAsArrayBuffer(chunk)
    })

    // 更新哈希值
    hash.update(buffer)
    currentChunk++

    // 回调进度
    if (onProgress) {
      onProgress({ loaded: end, total: file.size })
    }
  }

  return hash.toString() // 返回最终的十六进制SHA1
}
